import React, { ReactElement } from 'react';

import SheetContainer, { Content, Overlay, Sheet } from '../../../../../mobile/structural/sheet';
import { UseSheetReturnType } from '../../../../../mobile/structural/sheet/hooks/useSheet';
import TableCellAlignmentOptions from './TableCellAlignmentOptions';

import './MobileTableCellAlignmentSheet.scss';

type MobileTableCellAlignmentSheetProps = {
    sheetProps: UseSheetReturnType;
    commonTextAlignment: string | undefined;
    commonVerticalAlignment: string | undefined;
};

const MobileTableCellAlignmentSheet = ({
    sheetProps,
    commonTextAlignment,
    commonVerticalAlignment,
}: MobileTableCellAlignmentSheetProps): ReactElement => {
    return (
        <SheetContainer className="TableCellAlignmentSheet" {...sheetProps}>
            <Overlay />
            <Sheet>
                <Content>
                    <TableCellAlignmentOptions
                        commonTextAlignment={commonTextAlignment}
                        commonVerticalAlignment={commonVerticalAlignment}
                        layout="inline"
                    />
                </Content>
            </Sheet>
        </SheetContainer>
    );
};

export default MobileTableCellAlignmentSheet;
